<script lang="ts" setup>
  import { toRefs } from 'vue'
  import Accordion from 'primevue/accordion'
  import AccordionPanel from 'primevue/accordionpanel'
  import AccordionHeader from 'primevue/accordionheader'
  import AccordionContent from 'primevue/accordioncontent'

  interface Props {
    title?: string
    description?: string
    descriptionInline?: boolean
    disablePadding?: boolean
    asAccordion?: boolean
    autoOpen?: boolean
    bodyClass?: CssClassType
    asFlex?: boolean,
    disabled?: boolean
  }

  const props = defineProps<Props>()
  const emit = defineEmits(['toggle'])

  const { title, description, disablePadding, asAccordion, autoOpen, asFlex } = toRefs(props)

  const onToggle = () => {
    emit('toggle')
  }
</script>
<template>
  <div>
    <Accordion
      v-if="asAccordion"
      :value="autoOpen ? '0' : undefined"
      class="titrop-panel"
      @update:value="onToggle">
      <AccordionPanel value="0" :disabled="disabled">
        <AccordionHeader>
          <div :class="[{ 'flex items-center ': descriptionInline }, 'w-full']">
            <h3
              v-if="title"
              class="text-base font-semibold leading-6">
              <slot name="title">
                {{ title }}
              </slot>
            </h3>
            <slot
              v-else
              name="title" />
            <slot name="description">
              <span
                v-if="description"
                :class="[{ 'ml-3': descriptionInline }, 'opacity-80 text-sm']">
                {{ description }}
              </span>
            </slot>
          </div>
        </AccordionHeader>
        <AccordionContent :pt:content="[{ '!p-0': disablePadding }, bodyClass]">
          <slot />
        </AccordionContent>
      </AccordionPanel>
    </Accordion>

    <Card
      v-else
      :pt:content="[{ 'flex flex-col': asFlex }, bodyClass]"
      class="titrop-panel p-card p-component shadow sm:rounded-lg">
      <template #title>
        <div class="flex justify-between">
          <h3 class="text-base font-semibold leading-6">
            <slot name="title">
              {{ title }}
            </slot>
          </h3>
          <slot name="titleButton"></slot>
        </div>
      </template>
      <template #subtitle>
        <slot name="description">
          <p
            v-if="description"
            class="mt-1 text-sm">
            {{ description }}
          </p>
        </slot>
      </template>
      <template #content>
        <slot />
      </template>
    </Card>
  </div>
</template>
